export const companyEmail = `Support@TxRunoff.com`;
